<template lang="pug">
footer.l-article-illust(v-if="spot.illust")
  .l-article-illust__kumo1
  .l-article-illust__kumo2
  .l-article-illust__kumo3
  .l-article-illust__kumo4
  .l-article-illust__img(:style="styleObjectImg")


</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-illust
  position relative
  width 100%
  +pc()
    wh(100%,360px)
  +sp()
    wh(100%,450px)
  &__kumo1,
  &__kumo2,
  &__kumo3,
  &__kumo4
    background-color #FFF
    
  &__kumo1
    wh(160px,46px)
    pos(-32px,60px)
    border-radius 23px
  &__kumo2
    wh(220px,46px)
    pos(-32px,105px)
    border-radius 23px
  &__kumo3
    wh(320px,66px)
    posr(-33px,0px)
    border-radius 33px
  &__kumo4
    wh(180px,66px)
    posr(-33px,65px)
    border-radius 33px

  &__img
    position relative
    z-index 2
    background-size cover
    +pc()
      wh(480px,360px)
      pos(35px,35px)
    +sp()
      wh(600px,450px)
      pos(40px,40px)



</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name:'ArticleIllust',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const spot = computed(()=>{
      return store.api.getSpotById(route.params.id)
    })
    
    const styleObjectImg = computed(()=>{
      let obj = {}
      obj.backgroundImage = 'url('+ store.api.getSpotById(route.params.id).illust +')'
      return obj
    })

    return{
      spot,
      styleObjectImg
    }
  }
})
</script>
